class DrawAction {
    static get SELECT() {
        return "select"
    }
    static get RECTANGLE() {
        return "rectangle"
    }
    static get CIRCLE() {
        return "circle"
    }
    static get ARROW() {
        return "arrow"
    }
    static get ARROW_BLUE() {
        return "arrow_blue"
    }
    static get ARROW_RED() {
        return "arrow_red"
    }
    static get TEXT() {
        return "text"
    }
}

export default DrawAction;